import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import LocalizedStrings from 'localized-strings';

import useToast from 'components/ToastProvider/useToast';

import { SendTestInvoiceReminderDocument } from './sendDummyInvoiceReminder.gql';

const locales = new LocalizedStrings({
  en: {
    sendDummyReminderError:
      'An error occurred while sending the reminder test email. Please try again in a few minutes and don’t hesitate to contact us if the error remains.',
    sendDummyReminderSuccess: 'Reminder test email sent!',
  },
  fr: {
    sendDummyReminderError:
      'Une erreur est survenue lors de l’envoi de l’e-mail de relance de test. Essayez à nouveau dans quelques minutes et n’hésitez pas à nous contacter si le problème persiste.',
    sendDummyReminderSuccess: 'E-mail de relance de test envoyé !',
  },
});

type UseSendDummyInvoiceReminderToUserProps = {
  invoiceId: string;
};

const useSendDummyInvoiceReminderToUser = ({
  invoiceId,
}: UseSendDummyInvoiceReminderToUserProps) => {
  const { showToast } = useToast();
  const [sendDummyInvoiceReminder, { loading }] = useMutation(
    SendTestInvoiceReminderDocument,
  );
  const onSendDummyInvoiceReminderToUser = useCallback(async () => {
    try {
      await sendDummyInvoiceReminder({
        variables: {
          input: {
            invoiceId,
          },
        },
      });
      showToast({ message: locales.sendDummyReminderSuccess, type: 'success' });
    } catch (err) {
      showToast({ message: locales.sendDummyReminderError, type: 'error' });
    }
  }, [invoiceId, sendDummyInvoiceReminder, showToast]);

  return { loading, onSendDummyInvoiceReminderToUser };
};

export default useSendDummyInvoiceReminderToUser;
